import React from 'react'

export default function GuidedFileDropOverlay() {
  return (
    <div
      className="guided-file-drop-overlay"
      data-testid="guided-file-drop-overlay"
      role="status"
    >
      <strong>Drop files to upload</strong>
    </div>
  )
}
